import { render, staticRenderFns } from "./ViewGatButton.vue?vue&type=template&id=f643a34a&scoped=true&"
import script from "./ViewGatButton.vue?vue&type=script&lang=js&"
export * from "./ViewGatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f643a34a",
  null
  
)

export default component.exports